export default __webpack_public_path__ + "static/media/featureSegments.4d971557.png";